import React from "react";
const SVGComponent = ({ color = "#A9A9A9", ...props }) => (
  <svg
    width={120}
    height={86}
    viewBox="0 0 120 86"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_1_8456"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x={29}
      y={34}
      width={11}
      height={20}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.8235 38.9412C37.478 38.5879 37.3482 38.0613 37.4233 37.5729C37.446 37.425 37.4579 37.2735 37.4579 37.1192C37.4579 35.4847 36.1328 34.1597 34.4983 34.1597C32.8638 34.1597 31.5387 35.4847 31.5387 37.1192C31.5387 37.2735 31.5506 37.425 31.5733 37.5729C31.6484 38.0613 31.5186 38.5879 31.1731 38.9412C30.353 39.7798 29.8475 40.9273 29.8475 42.1928C29.8475 42.8655 29.9904 43.5049 30.2474 44.0822C30.4578 44.5548 30.3926 45.1245 30.0699 45.529C29.3986 46.3702 29.002 47.4097 29.002 48.5347C29.002 51.3367 31.4627 53.6082 34.4983 53.6082C37.5339 53.6082 39.9946 51.3367 39.9946 48.5347C39.9946 47.4097 39.598 46.3702 38.9267 45.529C38.604 45.1245 38.5388 44.5548 38.7492 44.0822C39.0062 43.5049 39.149 42.8655 39.149 42.1928C39.149 40.9273 38.6435 39.7798 37.8235 38.9412Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_1_8456)">
      <path
        d="M36.6121 37.1191C36.6121 37.2302 36.6037 37.3387 36.5875 37.4442L38.2589 37.7014C38.2882 37.5111 38.3033 37.3166 38.3033 37.1191H36.6121ZM34.4982 35.0051C35.6657 35.0051 36.6121 35.9516 36.6121 37.1191H38.3033C38.3033 35.0176 36.5997 33.314 34.4982 33.314V35.0051ZM32.3842 37.1191C32.3842 35.9516 33.3307 35.0051 34.4982 35.0051V33.314C32.3966 33.314 30.693 35.0176 30.693 37.1191H32.3842ZM32.4089 37.4442C32.3927 37.3387 32.3842 37.2302 32.3842 37.1191H30.693C30.693 37.3166 30.7081 37.5111 30.7374 37.7014L32.4089 37.4442ZM30.5684 38.3499C29.6001 39.3401 29.0018 40.6973 29.0018 42.1927H30.693C30.693 41.1569 31.1057 40.2193 31.7775 39.5323L30.5684 38.3499ZM29.0018 42.1927C29.0018 42.9862 29.1705 43.7425 29.4747 44.4259L31.0198 43.7381C30.81 43.267 30.693 42.7447 30.693 42.1927H29.0018ZM29.4088 45.0015C28.6261 45.9824 28.1562 47.2054 28.1562 48.5346H29.8474C29.8474 47.6137 30.171 46.7578 30.7307 46.0562L29.4088 45.0015ZM28.1562 48.5346C28.1562 51.8661 31.0606 54.4537 34.4982 54.4537V52.7625C31.8647 52.7625 29.8474 50.8072 29.8474 48.5346H28.1562ZM34.4982 54.4537C37.9358 54.4537 40.8401 51.8661 40.8401 48.5346H39.1489C39.1489 50.8072 37.1317 52.7625 34.4982 52.7625V54.4537ZM40.8401 48.5346C40.8401 47.2054 40.3703 45.9824 39.5875 45.0015L38.2656 46.0562C38.8254 46.7578 39.1489 47.6137 39.1489 48.5346H40.8401ZM39.5217 44.4259C39.8258 43.7425 39.9945 42.9862 39.9945 42.1927H38.3033C38.3033 42.7447 38.1863 43.267 37.9766 43.7381L39.5217 44.4259ZM39.9945 42.1927C39.9945 40.6973 39.3963 39.3401 38.428 38.3499L37.2189 39.5323C37.8907 40.2193 38.3033 41.1569 38.3033 42.1927H39.9945ZM39.5875 45.0015C39.468 44.8516 39.4355 44.6193 39.5217 44.4259L37.9766 43.7381C37.6419 44.4901 37.7397 45.3972 38.2656 46.0562L39.5875 45.0015ZM30.7374 37.7014C30.7797 37.976 30.6956 38.2198 30.5684 38.3499L31.7775 39.5323C32.3412 38.9559 32.517 38.1463 32.4089 37.4442L30.7374 37.7014ZM29.4747 44.4259C29.5608 44.6193 29.5284 44.8516 29.4088 45.0015L30.7307 46.0562C31.2566 45.3972 31.3545 44.4901 31.0198 43.7381L29.4747 44.4259ZM36.5875 37.4442C36.4794 38.1463 36.6551 38.9559 37.2189 39.5323L38.428 38.3499C38.3007 38.2198 38.2167 37.976 38.2589 37.7014L36.5875 37.4442Z"
        fill={color}
      />
    </g>
    <path
      d="M34.9216 62.91V49.2355M34.9216 49.2355V43.4614M34.9216 49.2355L33.2305 45.6901"
      stroke={color}
      strokeWidth={0.84559}
    />
    <path
      d="M78.0458 50.2259C78.0458 54.6624 81.6423 58.259 86.0789 58.259V59.1046C81.1754 59.1046 77.2002 55.1294 77.2002 50.2259H78.0458ZM86.0789 58.259C90.5155 58.259 94.112 54.6624 94.112 50.2259H94.9576C94.9576 55.1294 90.9825 59.1046 86.0789 59.1046V58.259ZM94.112 50.2259C94.112 45.7893 90.5155 42.1928 86.0789 42.1928V41.3472C90.9825 41.3472 94.9576 45.3223 94.9576 50.2259H94.112ZM86.0789 42.1928C81.6423 42.1928 78.0458 45.7893 78.0458 50.2259H77.2002C77.2002 45.3223 81.1754 41.3472 86.0789 41.3472V42.1928Z"
      fill={color}
    />
    <path
      d="M86.1913 62.9101V54.3111M86.1913 54.3111L88.1228 51.6431M86.1913 54.3111V52.1386M86.1913 48.2749V52.1386M86.1913 52.1386L84.3887 50.3359"
      stroke={color}
      strokeWidth={0.84559}
    />
    <path
      d="M97.0722 21.4944V63.7364C97.0722 64.3499 96.5082 64.8082 95.9077 64.6827C72.4157 59.773 48.1623 59.773 24.6703 64.6827C24.0699 64.8082 23.5059 64.3499 23.5059 63.7364V21.4944C23.5059 20.881 24.0699 20.4226 24.6704 20.5481C48.1623 25.4578 72.4157 25.4578 95.9077 20.5481C96.5082 20.4226 97.0722 20.881 97.0722 21.4944Z"
      stroke={color}
      strokeWidth={0.84559}
      strokeLinejoin="round"
    />
    <path
      d="M80.2043 29.0859H40.3735C38.7633 29.0859 37.458 30.3659 37.458 31.9449V51.5947C37.458 53.1737 38.7633 54.4536 40.3735 54.4536H80.2043C81.8145 54.4536 83.1199 53.1737 83.1199 51.5947V31.9449C83.1199 30.3659 81.8145 29.0859 80.2043 29.0859Z"
      fill="white"
      stroke={color}
      strokeWidth={0.84559}
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
    <path
      d="M83.1198 42.7435L78.3163 37.9054C77.6548 37.2391 76.5771 37.2392 75.9157 37.9057L66.208 47.689"
      stroke={color}
      strokeWidth={0.84559}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M71.2819 52.7622L64.0218 45.5021C63.3614 44.8417 62.2906 44.8417 61.6302 45.5021L56.0613 51.071L54.3701 52.7622"
      stroke={color}
      strokeWidth={0.84559}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.2002 36.7891H60.784"
      stroke={color}
      strokeWidth={0.84559}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.2002 40.7451H60.784"
      stroke={color}
      strokeWidth={0.84559}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.2002 42.8896H53.963"
      stroke={color}
      strokeWidth={0.84559}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.2002 46.2837H48.4571"
      stroke={color}
      strokeWidth={0.84559}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M67.0548 52.7627H47.6062C46.6722 52.7627 45.915 53.5199 45.915 54.4539C45.915 55.3879 46.6722 56.1451 47.6062 56.1451H67.0548C67.9888 56.1451 68.746 55.3879 68.746 54.4539C68.746 53.5199 67.9888 52.7627 67.0548 52.7627Z"
      fill="white"
      stroke={color}
      strokeWidth={0.84559}
    />
    <path
      d="M72.9732 52.7627H71.282C70.348 52.7627 69.5908 53.5199 69.5908 54.4539C69.5908 55.3879 70.348 56.1451 71.282 56.1451H72.9732C73.9072 56.1451 74.6644 55.3879 74.6644 54.4539C74.6644 53.5199 73.9072 52.7627 72.9732 52.7627Z"
      fill="white"
      stroke={color}
      strokeWidth={0.84559}
    />
    <path
      d="M31.623 32.3118L31.9146 32.0056L31.6085 31.7141L31.3169 32.0202L31.623 32.3118ZM28.4602 32.564L28.7166 32.2278L28.4231 32.004L28.1617 32.2646L28.4602 32.564ZM27.6986 29.7722L27.5938 30.1818L27.9506 30.273L28.09 29.9322L27.6986 29.7722ZM32.2791 30.6716H31.8563V31.0944H32.2791V30.6716ZM29.9009 33.4726C30.6989 33.4726 31.4195 33.1384 31.9292 32.6034L31.3169 32.0202C30.9602 32.3946 30.458 32.627 29.9009 32.627V33.4726ZM28.2039 32.9002C28.6748 33.2592 29.2635 33.4726 29.9009 33.4726V32.627C29.4551 32.627 29.0453 32.4784 28.7166 32.2278L28.2039 32.9002ZM27.2848 33.4726C27.86 33.4726 28.3816 33.2394 28.7587 32.8634L28.1617 32.2646C27.9366 32.489 27.6272 32.627 27.2848 32.627V33.4726ZM25.1973 31.3851C25.1973 32.538 26.1319 33.4726 27.2848 33.4726V32.627C26.5989 32.627 26.0429 32.071 26.0429 31.3851H25.1973ZM27.2848 29.2975C26.1319 29.2975 25.1973 30.2322 25.1973 31.3851H26.0429C26.0429 30.6992 26.5989 30.1431 27.2848 30.1431V29.2975ZM27.8034 29.3626C27.6371 29.32 27.4633 29.2975 27.2848 29.2975V30.1431C27.392 30.1431 27.4955 30.1567 27.5938 30.1818L27.8034 29.3626ZM29.9009 27.8706C28.7281 27.8706 27.7247 28.5912 27.3073 29.6122L28.09 29.9322C28.3819 29.2181 29.0833 28.7162 29.9009 28.7162V27.8706ZM32.7019 30.6716C32.7019 29.1247 31.4478 27.8706 29.9009 27.8706V28.7162C30.9808 28.7162 31.8563 29.5916 31.8563 30.6716H32.7019ZM32.2791 31.0944C32.571 31.0944 32.8076 31.331 32.8076 31.6229H33.6532C33.6532 30.864 33.038 30.2488 32.2791 30.2488V31.0944ZM32.8076 31.6229C32.8076 31.9148 32.571 32.1514 32.2791 32.1514V32.997C33.038 32.997 33.6532 32.3818 33.6532 31.6229H32.8076ZM32.2791 32.1514C32.1376 32.1514 32.0098 32.0964 31.9146 32.0056L31.3314 32.6179C31.5776 32.8524 31.9118 32.997 32.2791 32.997V32.1514Z"
      fill={color}
    />
    <path
      d="M93.2283 37.0799L92.9565 36.7562L93.2101 36.543L93.4778 36.7385L93.2283 37.0799ZM97.0719 38.3877L97.4947 38.3878V38.8105H97.0719V38.3877ZM97.0721 28.2407V27.8179H97.4949V28.2407L97.0721 28.2407ZM91.1293 32.6174L91.548 32.6767L91.5051 32.9787L91.2051 33.0333L91.1293 32.6174ZM93.4778 36.7385C94.5284 37.506 95.8461 37.9649 97.0719 37.9649V38.8105C95.6492 38.8105 94.1596 38.2837 92.9789 37.4213L93.4778 36.7385ZM97.0719 38.3877C96.6491 38.3877 96.6491 38.3877 96.6491 38.3877C96.6491 38.3875 96.6491 38.3868 96.6491 38.3864C96.6491 38.3855 96.6492 38.3841 96.6492 38.3823C96.6492 38.3788 96.6492 38.3735 96.6492 38.3664C96.6492 38.3523 96.6492 38.3313 96.6492 38.3034C96.6492 38.2477 96.6492 38.1651 96.6492 38.0571C96.6492 37.8412 96.6492 37.524 96.6493 37.1187C96.6493 36.3081 96.6494 35.1454 96.6494 33.737H97.495C97.495 35.1454 97.4949 36.3081 97.4949 37.1187C97.4948 37.5241 97.4948 37.8413 97.4948 38.0572C97.4948 38.1652 97.4948 38.2478 97.4948 38.3035C97.4948 38.3313 97.4948 38.3524 97.4948 38.3665C97.4948 38.3735 97.4948 38.3789 97.4948 38.3824C97.4948 38.3842 97.4947 38.3855 97.4947 38.3865C97.4947 38.3869 97.4947 38.3876 97.4947 38.3878C97.4947 38.3877 97.4947 38.3879 97.4947 38.3878C97.4947 38.3878 97.4947 38.3878 97.0719 38.3877ZM96.6494 33.737L96.6493 28.2407L97.4949 28.2407L97.495 33.737H96.6494ZM97.0721 28.6635C94.5661 28.6635 91.9203 30.0509 91.548 32.6767L90.7107 32.558C91.1679 29.334 94.3584 27.8179 97.0721 27.8179V28.6635ZM91.2051 33.0333C90.2135 33.2139 89.4618 34.0827 89.4618 35.1262H88.6162C88.6162 33.6668 89.6673 32.4539 91.0535 32.2014L91.2051 33.0333ZM89.4618 35.1262C89.4618 36.3011 90.4143 37.2536 91.5892 37.2536V38.0991C89.9473 38.0991 88.6162 36.7681 88.6162 35.1262H89.4618ZM91.5892 37.2536C92.1102 37.2536 92.5865 37.0668 92.9565 36.7562L93.5003 37.4036C92.9837 37.8375 92.3164 38.0991 91.5892 38.0991V37.2536Z"
      fill={color}
    />
    <path
      d="M25.6211 37.542C26.1848 37.542 27.3123 37.8802 27.3123 39.2332C27.3123 38.6694 27.6505 37.542 29.0035 37.542"
      stroke={color}
      strokeWidth={0.84559}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M85.6572 29.0859C86.221 29.0859 87.3484 29.4242 87.3484 30.7771C87.3484 30.2134 87.6866 29.0859 89.0396 29.0859"
      stroke={color}
      strokeWidth={0.84559}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SVGComponent;
